module.exports = __webpack_public_path__ + "static/img/cont60 (6).8c9a904.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont60 (6).jpg
// module id = 4H70
// module chunks = 0